import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Disabler } from 'lib/ui/components'
import { PlaceOrder } from 'app/sofia/scenes/Checkout/components/PlaceOrder'
import { useCheckout, EmailForm, Nav, Totals } from 'lib/modules/checkout'
import { PaymentMethods } from 'components/PaymentMethods'
import { PaymentOptions } from 'components/PaymentOptions'
import { BillingAddress } from './components/BillingAddress'
import {
  Container,
  CheckoutLayout,
  CheckoutMain,
  CheckoutAside
} from '../styled'
import { captureEmail } from 'modules/listrak'

export const Billing = () => {
  const {
    validateShippingAddress,
    validateShippingMethod,
    requiresShipping,
    orderTotal,
    billingAddress
  } = useCheckout()
  const history = useHistory()
  const isValid = validateShippingAddress() && validateShippingMethod()
  const needsShipping = requiresShipping()

  useEffect(() => {
    if (!isValid) {
      history.replace('/checkout/shipping')
    }
  }, [isValid, history])

  return (
    <>
      <Nav />
      <Container>
        <h1>
          Payment & Billing Information
        </h1>
        <CheckoutLayout>
          <CheckoutMain>
            {!!orderTotal && (
              <Disabler disabled={billingAddress.isFetching}>
                <PaymentOptions />
                <PaymentMethods />
              </Disabler>
            )}

            {!needsShipping && (
              <EmailForm
                interceptBlur={(e) => {
                  captureEmail(e.value)
                }}
              />
            )}

            <h2>
              Billing Address
            </h2>

            <BillingAddress />
          </CheckoutMain>
          <CheckoutAside>
            <div>
              <Totals />
              <PlaceOrder />
            </div>
          </CheckoutAside>
        </CheckoutLayout>
      </Container>
    </>
  )
}
